
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";

@Component
export default class FormularioLandingComponent extends Mixins(FormValidator) {
  private bVerValidadorFibe = false;
  private window = window;
  private verResultadoValidacionFibe = false;
  private formattedRut = "";
  private dataForm: any = {
    rut: ""
  };

  @Watch("formattedRut")
  private formatRut(newValue: string) {
    newValue = newValue
      .replace(/\./g, "")
      .replace(/-/g, "")
      .replace(/\s/g, "")
      .toUpperCase();
    this.dataForm.rut = this.rutSanitize(newValue);
    if (newValue.length > 5) {
      const rut = newValue
        .substring(0, newValue.length - 1)
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      const dv = newValue.substring(newValue.length - 1);
      this.formattedRut = `${rut}-${dv}`;
    } else {
      this.formattedRut = newValue
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
        .toUpperCase();
    }
  }

  private mounted() {
    let hoy = new Date();
    let fechaLimite = new Date("2026-01-09 16:30:00");
    if (hoy >= fechaLimite) {
      this.$router.push("/2026/postulacion-terminada");
    }
  }

  private toLink(url, target: string) {
    window.open(url, target);
  }

  private verValidadorFibe(tipo: string) {
    this.bVerValidadorFibe = true;
  }

  private validarFIBE() {
    let path = "";
    if (this.dataForm.rut.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar el Rut",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }
    if (!this.validateRut(this.dataForm.rut)) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un Rut válido",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }
    path = "?rut=" + this.dataForm.rut;
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("/postulacion/check/fibe/2026" + path)
      .then((res: any) => {
        this.verResultadoValidacionFibe = false;
        this.$q.loading.hide();
        this.verFormulario(this.dataForm.rut);
      })
      .catch((err: any) => {
        if (err.response.data.message == "NO_REGISTRADO") {
          this.verResultadoValidacionFibe = true;
          this.$q.loading.hide();
          return;
        } else if (err.response.data.message == "UTILIZADO") {
          Notify.create({
            color: "negative",
            message:
              "El Rut ingresado ya cuenta con una postulación para el beneficio FIBE.",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          })
          this.$q.loading.hide();
          this.verResultadoValidacionFibe = false;
          return;
        } else {
          // Error
          Notify.create({
            color: "negative",
            message: "Ha ocurrido un error, intentelo nuevamente",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          this.$q.loading.hide();
          this.verResultadoValidacionFibe = false;
          return;
        }
      });
  }
  private volver() {
    this.$router.go(0);
  }
  private verFormulario(rut = null) {
    if (rut) {
      this.$router.push({ name: "formulario2026", query: { rut: rut } });
    } else {
      this.$router.push({ name: "formulario2026" });
    }
  }

  public validateRut(newValue: string) {
    var texto = newValue;
    var tmpstr = "";
    for (let i = 0; i < texto.length; i++)
      if (
        texto.charAt(i) != " " &&
        texto.charAt(i) != "." &&
        texto.charAt(i) != "-"
      )
        tmpstr = tmpstr + texto.charAt(i);
    texto = tmpstr;
    var largo = texto.length;
    if (largo < 2) {
      this.validRut = false;
      return false;
    }
    for (let i = 0; i < largo; i++) {
      if (
        texto.charAt(i) != "0" &&
        texto.charAt(i) != "1" &&
        texto.charAt(i) != "2" &&
        texto.charAt(i) != "3" &&
        texto.charAt(i) != "4" &&
        texto.charAt(i) != "5" &&
        texto.charAt(i) != "6" &&
        texto.charAt(i) != "7" &&
        texto.charAt(i) != "8" &&
        texto.charAt(i) != "9" &&
        texto.charAt(i) != "k" &&
        texto.charAt(i) != "K"
      ) {
        this.validRut = false;
        return false;
      }
    }
    var invertido = "";
    for (let i = largo - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + texto.charAt(i);
    var dtexto = "";
    dtexto = dtexto + invertido.charAt(0);
    dtexto = dtexto + "-";
    var cnt = 0;
    for (let i = 1, j = 2; i < largo; i++, j++) {
      //alert("i=[" + i + "] j=[" + j +"]" );
      if (cnt == 3) {
        dtexto = dtexto + ".";
        j++;
        dtexto = dtexto + invertido.charAt(i);
        cnt = 1;
      } else {
        dtexto = dtexto + invertido.charAt(i);
        cnt++;
      }
    }
    invertido = "";
    for (let i = dtexto.length - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + dtexto.charAt(i);

    if (this.revisarDigito2(texto)) {
      this.validRut = true;
      return true;
    }
    this.validRut = false;
    return false;
  }
  public revisarDigito(dvr: string) {
    var dv = dvr + "";
    if (
      dv != "0" &&
      dv != "1" &&
      dv != "2" &&
      dv != "3" &&
      dv != "4" &&
      dv != "5" &&
      dv != "6" &&
      dv != "7" &&
      dv != "8" &&
      dv != "9" &&
      dv != "k" &&
      dv != "K"
    ) {
      return false;
    }
    return true;
  }
  public revisarDigito2(crut: string) {
    var largo = crut.length;
    if (largo < 2) {
      return false;
    }
    if (largo > 2) var rut = crut.substring(0, largo - 1);
    else rut = crut.charAt(0);
    var dv = crut.charAt(largo - 1);
    this.revisarDigito(dv);
    if (rut == null || dv == null) return 0;
    var dvr = "0";
    var suma = 0;
    var mul = 2;
    for (let i = rut.length - 1; i >= 0; i--) {
      suma = suma + parseInt(rut.charAt(i), 10) * mul;
      if (mul == 7) mul = 2;
      else mul++;
    }
    var res = suma % 11;
    if (res == 1) dvr = "k";
    else if (res == 0) dvr = "0";
    else {
      var dvi = 11 - res;
      dvr = dvi + "";
    }
    if (dvr != dv.toLowerCase()) {
      return false;
    }
    return true;
  }
  private rutSanitize(rut: string) {
    const temp = rut.replace(/\./g, "").replace(/-/g, "");
    const rutNumber = temp.substring(0, temp.length - 1);
    const dv = temp.substring(temp.length - 1);
    return `${rutNumber}-${dv}`;
  }

  //Legacy
  private validarRut = false;
  private bVerValidador = false;
  private validRut = true;
  private verResultadoValidacion = false;
  private resultadoTitulo = "";
  private resultadoMensaje = "";
  private resultadoPostular = false;

  private verValidador(tipo: string) {
    if (tipo == "rut") {
      this.validarRut = true;
    } else {
      this.validarRut = false;
    }
    this.bVerValidador = true;
  }
  private validarInicio() {
    let path = "";
    if (this.dataForm.rut.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar el Rut",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }
    if (!this.validateRut(this.dataForm.rut)) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un Rut válido",
        icon: "report_problem",
        position: "top",
        timeout: 3500
      });
      return;
    }
    path = "?rut=" + this.dataForm.rut;
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("/postulacion/check/2026" + path)
      .then((res: any) => {
        this.verResultadoValidacion = true;
        this.resultadoTitulo = "El Rut ingresado se encuentra aprobado";
        this.resultadoMensaje =
          "El Rut ingresado mantiene el beneficio automáticamente.";
        this.resultadoPostular = false;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.verResultadoValidacion = true;
        if (err.response.data.message == "NO_REGISTRADO") {
          this.resultadoTitulo =
            "El Rut ingresado no cuenta con una postulación";
          this.resultadoMensaje =
            "El Rut ingresado aún no cuenta con una postulación, puedes realizar tu postulación haciendo click en el siguiente botón.";
          this.resultadoPostular = true;
          return;
        } else if (err.response.data.message == "BENEFICIADO") {
          this.resultadoTitulo = "El Rut ingresado se encuentra aprobado";
          this.resultadoMensaje =
            "El Rut ingresado mantiene el beneficio automáticamente.";
          this.resultadoPostular = true;
          return;
        } else if (err.response.data.message == "REGISTRADO") {
          this.resultadoTitulo =
            "El Rut ingresado ya cuenta con una postulación";
          this.resultadoMensaje =
            "El Rut ingresado aún ya cuenta con una postulación.";
          this.resultadoPostular = false;
          return;
        } else if (err.response.data.message == "RECHAZADO") {
          this.resultadoTitulo =
            "El Rut ingresado ya cuenta con una postulación";
          this.resultadoMensaje =
            "El Rut ingresado aún ya cuenta con una postulación y esta fue RECHAZADA. Para más información contáctenos al correo dideco@quilpue.cl";
          this.resultadoPostular = false;
          return;
        } else if (err.response.data.message == "EN_REVISION") {
          this.resultadoTitulo =
            "El Rut ingresado ya cuenta con una postulación";
          this.resultadoMensaje =
            "El Rut ingresado aún ya cuenta con una postulación y esta se encuentra en proceso de REVISIÓN.";
          this.resultadoPostular = false;
          return;
        } else if (err.response.data.message == "APROBADO") {
          this.resultadoTitulo = "El Rut ingresado ha sido aprobado";
          this.resultadoMensaje =
            "El Rut ingresado aún ya cuenta con una postulación y esta se encuentra APROBADA.";
          this.resultadoPostular = false;
          return;
        } else {
          // Error
          Notify.create({
            color: "negative",
            message: "Ha ocurrido un error, intentelo nuevamente",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          this.verResultadoValidacion = false;
          return;
        }
      });
  }
}
